import { combineReducers, configureStore } from "@reduxjs/toolkit"
import allApplications from "redux/slice/applications/applicationSlice"
import allDonarMaster from "redux/slice/donation/donationMaster"
import allStaffs from "redux/slice/staff/staffSlice"
import allStudents from "redux/slice/students/studentsSlice"
import ForgotPasswordSlice from "redux/slice/user/forgotPasswordSlice"
import userSlice from "redux/slice/user/userSlice"
import allDonations_ from "redux/slice/donation/donations_"
import allReimbursements_ from "redux/slice/donation/reimbursement"
import ChatSlice from "redux/slice/chats/chatSlice"
import allApplicationRecommendations from "redux/slice/recommendation/recomendationSlice"
import allReturningStudents from "redux/slice/returningStudentsSlice/returningStudentSlice"
import allNotifications from "redux/slice/notifications/notificationSlice"
import allEmailTemplates from "redux/slice/emailTemplate/emailTemplateSlice"
import allScholarships from "redux/slice/scholarship/scholarshipSlice"
import allPayments from "redux/slice/payment/paymentSlice"
import allReporting from "redux/slice/reporting/reportingSlice"

const rootReducer = combineReducers({
  user: userSlice,
  allStaffs: allStaffs,
  allScholarships: allScholarships,
  allPayments: allPayments,
  allReporting: allReporting,
  allStudents: allStudents,
  allApplications: allApplications,
  allReturningStudents: allReturningStudents,
  allNotifications: allNotifications,
  allEmailTemplates: allEmailTemplates,
  allApplicationRecommendations: allApplicationRecommendations,
  allDonarMaster: allDonarMaster,
  allDonations_: allDonations_,
  allReimbursements_: allReimbursements_,
  ForgotPasswordBlock: ForgotPasswordSlice,
  allChats: ChatSlice,
})

export const store = configureStore({
  reducer: rootReducer,
})
